import * as Constants from './constants';
import * as API from './api';

export function loadList(page, filter) {
    return {
        type: "PROMISE",
        actions: [
            Constants.START_LOAD_FEEDS,
            Constants.FINISH_LOAD_FEEDS,
            Constants.ERROR_LOAD_FEEDS
        ],
        promise: API.loadList(page, filter)
    };
}

export function addRead(id) {
    return {
        type: "PROMISE",
        actions: [
            Constants.START_ADD_READ_FEED,
            Constants.FINISH_ADD_READ_FEED,
            Constants.ERROR_ADD_READ_FEED
        ],
        promise: API.addReadedPost(id)
    };
}

export function addBookmark(id) {
    return {
        type: "PROMISE",
        actions: [
            Constants.START_ADD_BOOKMARK_FEED,
            Constants.FINISH_ADD_BOOKMARK_FEED,
            Constants.ERROR_ADD_BOOKMARK_FEED
        ],
        promise: API.addBookmark(id)
    };
}

export function loadBookmarks(filter) {
    return {
        type: "PROMISE",
        actions: [
            Constants.START_LOAD_BOOKMARKS,
            Constants.FINISH_LOAD_BOOKMARKS,
            Constants.ERROR_LOAD_BOOKMARKS
        ],
        promise: API.loadBookmarks(filter)
    };
}


export function removeBookmarks(items) {
    return {
        type: "PROMISE",
        actions: [
            Constants.START_REMOVE_BOOKMARK,
            Constants.FINISH_REMOVE_BOOKMARK,
            Constants.ERROR_REMOVE_BOOKMARK
        ],
        promise: API.removeBookmarks(items)
    };
}

export function loadFeedInfo(item_id) {
    return {
        type: "PROMISE",
        actions: [
            Constants.START_LOAD_FEED,
            Constants.FINISH_LOAD_FEED,
            Constants.ERROR_LOAD_FEED,
        ],
        promise: API.loadFeed(item_id)
    };
}


// WEBPACK FOOTER //
// ./src/models/feeds/actions.js